import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import React from 'react';
import styles from './BigNumbersIndicator.module.scss';

export interface IBoxIndicator {
  indicator: number;
  decimal?: number;
}

export const BigNumbersIndicator = ({ indicator, decimal = 2 }: IBoxIndicator) => {
  const indicatorRound = Math.round(indicator * 10) / 10;

  if (indicatorRound === 0) {
    return <p className={styles['indicator-zero']}>0,0 %</p>;
  }

  return (
    <div className={styles['indicator-wrapper']}>
      {indicatorRound > 0 ? <ArrowUpwardIcon className={styles['positive-icon']} /> : <ArrowDownwardIcon className={styles['negative-icon']} />}
      <p className={styles[indicatorRound > 0 ? 'positive' : 'negative']}>{indicatorRound.toFixed(decimal).replace('.', ',').replace('-', '')} %</p>
    </div>
  );
};
